<template>
    <u-tabs-inline v-model="TabsPrimaryValue" v-bind="$attrs" @change="TabsPrimaryValueChange" color="white">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tabs-inline>
</template>

<script>
import UTabsInline from "@/components/publish/styles/tabs/u-tabs-inline.vue";

export default {
    props: {
        value: { type: [Number, String] },
    },
    components: {
        UTabsInline,
    },
    data() {
        return {
        };
    },
    computed: {
        TabsPrimaryValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
    mounted() {},
    methods: {
        TabsPrimaryValueChange(newValue) {
            this.TabsPrimaryValue = newValue;
        },
    },
};
</script>

<style lang="scss" scoped></style>